export const LOADING = 'LOADING'
export const POKEMON_ERROR = 'POKEMON_ERROR'

export const GET_ALL_POKEMONS = 'GET_ALL_POKEMONS'
export const GET_POKEMONS_BY_TYPE = 'GET_POKEMONS_BY_TYPE'
export const GET_POKEMON_BY_ID = 'GET_POKEMON_BY_ID'
export const GET_ROULETTE_POKEMONS = 'GET_ROULETTE_POKEMONS'

export const CATCH_ROULETTE = 'CATCH_ROULETTE'
export const CATCH_POKEMON = 'CATCH_POKEMON'
export const DELETE_POKEMON = 'DELETE_POKEMON'